import { Button } from 'antd';
import Container from '../../components/Layout/Container';
import common from './Common.module.scss';
import local from './SectionMidBreak.module.scss';
import avatarImg from '../../assets/images/micro-reset.svg';
import { useSurveyContext } from '../../context/SurveyContext';

const Section2MidBreak = () => {
  const { setCurrentStep, setCurrentSubsection } = useSurveyContext();

  const handleContinue = () => {
    // Continue from the next subsection after the mid-break
    setCurrentSubsection(6); // Continue from subsection 7 (index 6)
    setCurrentStep('section-2');
  };

  return (
    <div className={`${common.surveyWrapper} ${local.surveyWrapper}`}>
      <Container>
        <div className={common.surveyAvatarWrapper}>
          <img src={avatarImg} alt="Micro Reset Avatar" className={common.surveyAvatar} />
        </div>
        <div className={common.surveyTextSection}>
          <h1 className={common.surveyTitle}>Micro-reset</h1>
          <div className={`${common.surveyParagraphs} ${local.centeredText}`}>
            <p>
              Did you know a single short session of slow, deep breathing (think ~5 s in, ~5 s out) can reduce same-day state anxiety compared with doing nothing? If it helps, try a minute now and notice how your body settles.
            </p>
            <p style={{ marginTop: 16, marginBottom: 16, fontSize: 14, color: '#666', fontStyle: 'italic' }}>
              Source: brief slow-paced breathing study (2025)
            </p>
            <p>
              Feel free to take a breath—then hit Continue when you're ready.
            </p>
          </div>
          <div className={common.surveyButtonWrapper}>
            <Button 
              type="primary" 
              className={common.surveyButton} 
              onClick={handleContinue}
              block
            >
              Continue
            </Button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Section2MidBreak;
